import React from "react";
import { useTranslation } from "react-i18next";
import { ISummaryAmount } from "us.collection.case/interfaces";
import { $Table, $Skeleton, $AmountLabel } from "us.common/components";

type CreditorInfoProps = {
    isFetchingCreditorInfo: boolean;
    creditorTableData: any[];
    summaryData: ISummaryAmount[];
    columns: any;
};
/**
 * @description
 * CreditorInfo Component
 * ----------------------
 * This component displays creditor-related information in a table format.
 *
 * Features:
 *  - Shows creditor data in a table
 *  - Displays loading skeleton while fetching data
 *  - Provides a summary row with:
 *      - Total number of cases
 *      - Total balance amount
 */
const CreditorInfo: React.FC<CreditorInfoProps> = (props) => {
    const { t } = useTranslation();
    const { isFetchingCreditorInfo, creditorTableData, summaryData, columns } =
        props;

    return (
        <div className="pl-1 pb-4">
            <$Skeleton
                loading={isFetchingCreditorInfo}
                active
                paragraph={{
                    rows: 2,
                }}
            >
                <$Table
                    rowKey="pid"
                    dataSource={creditorTableData}
                    size="small"
                    className=""
                    bordered
                    columns={columns}
                    pagination={false}
                    summary={() => (
                        <$Table.Summary.Row>
                            <$Table.Summary.Cell index={0}>
                                <h3 className="mb-0 py-2">{t("US.COMMON:COMMON.TOTAL")}</h3>
                            </$Table.Summary.Cell>
                            <$Table.Summary.Cell index={0}>
                                <strong>{summaryData[0].numberOfCases}</strong>
                            </$Table.Summary.Cell>
                            <$Table.Summary.Cell index={0} className="text-right">
                                <strong>
                                    {summaryData[0].balance != "0.00" && (
                                        <$AmountLabel value={Number(summaryData[0].balance)} />
                                    )}
                                    {summaryData[0].balance == "0.00" && "-"}
                                </strong>
                            </$Table.Summary.Cell>
                        </$Table.Summary.Row>
                    )}
                />
            </$Skeleton>
        </div>
    );
};

export default CreditorInfo;
